import React, { useEffect, forwardRef, ForwardedRef } from 'react';
import classnames from 'classnames';
import { useShopPayContext } from '../../contexts/ShopPayContext';
import styles from './ShopPayButton.module.scss';

import {
  STRIPE_EXPRESS_CHECKOUT_FEATURE_TOGGLE,
  STRIPE_REGULAR_CHECKOUT_FEATURE_TOGGLE,
} from '../../utils/common/constants';

const isStripeRegularCheckoutEnabled = window?.purTogglesEnabled?.(
  STRIPE_REGULAR_CHECKOUT_FEATURE_TOGGLE,
);

const isStripeExpressCheckoutEnabled = window?.purTogglesEnabled?.(
  STRIPE_EXPRESS_CHECKOUT_FEATURE_TOGGLE,
);


type ShopPayButtonProps = {
  id: string;
  isExpressCheckout?: boolean;
};

const ShopPayButton = forwardRef(
  (
    { id, isExpressCheckout = false }: ShopPayButtonProps,
    ref: ForwardedRef<HTMLDivElement | null>,
  ) => {
    const { isShopPaySessionCreated } = useShopPayContext();

    useEffect(() => {
      if (isShopPaySessionCreated && window.ShopPay && id !== '') {
        // eslint-disable-next-line no-console
        console.log('ShopPay: rendering button with id:', id);
        window.ShopPay?.PaymentRequest.createButton().render(`#${id}`);
      }
    }, [id, isShopPaySessionCreated]);

    if (!isShopPaySessionCreated || id === '') return null;

    return (
      <div
        className={
          isExpressCheckout
            ? classnames(styles['container-express-checkout'], {
                [styles.stripe]: isStripeExpressCheckoutEnabled,
              })
            : classnames(styles['container-regular-checkout'], {
                [styles.stripe]: isStripeRegularCheckoutEnabled,
              })
        }
      >
        <div id={id} ref={ref} />
      </div>
    );
  },
);

export default ShopPayButton;
